export const MAX_HEIGHT_DEFAULT = 'calc(100vh - 76px)';
export const MAX_HEIGHT_WITH_TITLE_AND_FOOTER = 'calc(100vh - 205px)';
export const MAX_HEIGHT_WITH_TITLE_AND_COLUM_FOOTER = 'calc(100vh - 257px)';
export const MAX_HEIGHT_WITH_COLUM_FOOTER = 'calc(100vh - 200px)';
export const MAX_HEIGHT_WITH_FOOTER = 'calc(100vh - 148px)';
export const MAX_HEIGHT_WITH_TITLE = 'calc(100vh - 133px)';
export const PAGE_SCROLL_VISIBLE_TIME = 100;
export const PAGE_SCROLL_NOT_VISIBLE_TIME = 0;
export const ANIMATION_TRANSITION_DURATION = 150;
export const MOBILE_DROPDOWN_SLIDER_CLASS = 'mobile-dropdown-slider';
